import React from 'react';
import PropTypes from 'prop-types';

import axios from 'axios';
import debounce from 'lodash/debounce';

import { MenuItem, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import TextField from '../../../../../../Common/UI/TextField';
import SelectTextField from '../../../../../../Common/UI/SelectTextField';

class StringRule extends React.Component {
    static propTypes = {
        tree: PropTypes.object.isRequired,
        field: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
        min: PropTypes.number,
        max: PropTypes.number
    };

    constructor (props) {
        super(props);

        this.state = {
            options: []
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleAutocompleteInputChange = this.handleAutocompleteInputChange.bind(this);
        this.handleAutocompleteChange = this.handleAutocompleteChange.bind(this);

        this.debouncedAutocomplete = debounce((facetId, facetValue) => {
            return axios.get(`/api/facets/${facetId}/autocomplete?value=${facetValue}`)
                .then(response => {
                    this.setState({ options: response.data });
                }).catch(error => {
                    if (axios.isCancel(error)) {
                        console.log('cancel');
                    } else {
                        console.error(error);
                    }
                });
        }, 500);

        this.debouncedHandleChange = debounce(this.handleChange, 1000);
    }

    handleChange (name, value) {
        const { tree, onChange } = this.props;
        const newTree = { ...tree };
        newTree.properties = {
            ...newTree.properties,
            [name]: value
        };
        
        const operator = newTree.properties?.operator;
        const fieldValue = newTree.properties?.value;
        if(operator !== 'ilike') newTree['isValid'] = false;
        if(operator === 'ilike' && (fieldValue?.length > 0)) newTree['isValid'] = true;
        if(operator === 'ilike' && (fieldValue === undefined)) newTree['isValid'] = false;

        onChange(newTree);
    }

    handleAutocompleteInputChange (event, value) {
        const { tree, field } = this.props;
        this.setState({
            value: value,
            options: []
        });
        this.debouncedHandleChange('value', value);
        if (field.settings.autocompleteFacetId) {
            this.debouncedAutocomplete(field.settings.autocompleteFacetId, value);
        } else if (field.settings.autocompleteOptions) {
            this.setState({
                options: field.settings.autocompleteOptions.filter(option => option.includes(value))
            });
        }
    }

    handleAutocompleteChange (event, value) {
        const { field } = this.props;
        this.setState({
            value: value
        });
        this.debouncedHandleChange.cancel;
        this.handleChange('value', value);
    }

    render () {
        const { tree, field, min, max } = this.props;
        const { properties } = tree;
        
        return (
            <>
                <SelectTextField
                    name="operator"
                    onChange={event => this.handleChange(event.target.name, event.target.value)}
                    value={tree.properties.operator || ''}
                    placeholder="Operator"
                    size="small"
                >
                    {/* <MenuItem value="==">{'Equals'}</MenuItem> */}
                    <MenuItem value="ilike">{'Matches'}</MenuItem>
                </SelectTextField>
                {
                    (field.settings && field.settings.autocomplete) ?
                        <Autocomplete
                            renderInput={params =>
                                <TextField
                                    inputRef={params.InputProps.ref}
                                    inputProps={params.inputProps}
                                    name="value"
                                    size="small"
                                    placeholder={field.placeholder || 'Value'}

                                />
                            }
                            freeSolo
                            getOptionLabel={option => option}
                            options={this.state.options}
                            // groupBy={option => fields[option].category}
                            value={tree.properties.value || ''}
                            onChange={this.handleAutocompleteChange}
                            onInputChange={this.handleAutocompleteInputChange}
                            disableClearable
                        /> :
                        <TextField
                            name="value"
                            size="small"
                            onChange={event => this.handleChange(event.target.name, event.target.value)}
                            placeholder={field.placeholder || 'Value'}
                            value={tree.properties.value || ''}
                        />
                }
            </>
        );
    }
}

export default StringRule;